import { Component, Input } from '@angular/core';
import { BreadcrumbSegment } from './breadcrumb-segment';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss'],
  imports: [
    CommonModule,
    RouterModule,
  ],
})
export class BreadcrumbComponent {
  @Input() segments: BreadcrumbSegment[];
}
